import { render, staticRenderFns } from "./SumjSide.vue?vue&type=template&id=e87d6e16&"
import script from "./SumjSide.vue?vue&type=script&lang=js&"
export * from "./SumjSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports